































import Vue from "vue";
import BoutonCard from "@/features/home/components/bouton-card.vue";
import appModalCustom from "@/components/app-modal-custom.vue"
import router from '@/router';
import { mapGetters } from "vuex";

export default Vue.extend({
  components: {
    BoutonCard,
    appModalCustom 
  },
  data() {
    return {
      showModal : false,
      modalTitle : " ",
      modalParagraph :" ",
      modalBq : " ",
      modalBs : " ",
      route : 'home',
      btnQuitter : ""
    }
  },
  props:{
    items:{
      type:Array,
      default:function () { return [] },
    },
    nbrEtabs : {
        // Pour la condition (Afficher le modal a plus de 1 etablissement)
        // Another comment for retry preint
        type : Number,
         default: 0
      },
      },
    methods : {
      link(value:string) {      
      router.push({ name: value });
    },
    clickEtablissement(){
        this.showModal = true ;
        this.modalTitle = this.$t('anmobi.modalVerification.title_etab') as string ;
        this.modalParagraph = this.$t('anmobi.modalVerification.confirmation_change') as string ;
        this.modalBq = this.$t('anmobi.modalVerification.btn_changer_etab') as string ;
        this.modalBs = this.$t('anmobi.modalVerification.btn_pas_changer_etab') as string ;
        this.route = 'etablissements' ;
    },
    clickQuit(){
        this.showModal = true ;
        this.modalTitle = this.$t('anmobi.modalVerification.quit_msg') as string ;
        this.modalParagraph = this.$t('anmobi.modalVerification.confirmation_quit') as string ;
        this.modalBq = this.$t('anmobi.modalVerification.quit_app') as string ;
        this.modalBs = this.$t('anmobi.modalVerification.stay_app') as string ;
        this.route = 'logoutuser' ;
    },
    btnStay(){
        this.showModal = false
    },
    redirectTo(){
      router.push({ name: this.route });
    },
    }
});
